function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256C511.835,114.683,397.317,0.165,256,0z  M125.163,306.432c-28.628-6.971-52.957-25.757-66.944-51.691C43.271,229.18,43.035,197.6,57.6,171.819 c12.773-22.702,31.521-41.472,54.208-54.272c39.872-23.019,76.565-21.333,91.328,4.267c7.114,15.064,10.362,31.664,9.451,48.299 c-0.861,11.769,1.099,23.573,5.717,34.432c-28.433,20.518-34.849,60.201-14.331,88.635c1.801,2.496,3.782,4.858,5.926,7.067 C182.734,309.94,153.447,312.078,125.163,306.432z M353.813,427.925v-0.021c-14.653,25.732-41.878,41.738-71.488,42.027 c-26.056,0.299-51.695-6.549-74.133-19.797c-39.872-23.061-56.725-55.701-41.984-81.259c9.485-13.703,22.235-24.826,37.099-32.363 c10.579-5.132,19.796-12.69,26.901-22.059c31.985,14.308,69.514-0.022,83.822-32.008c1.273-2.845,2.334-5.78,3.175-8.781 c22.051,18.691,38.606,43.026,47.893,70.4C373.39,372.354,369.288,402.834,353.813,427.925z M398.656,277.333 c-16.608-1.366-32.614-6.851-46.571-15.957c-9.778-6.663-21.018-10.871-32.768-12.267c-3.247-34.593-33.923-60.005-68.516-56.758 c-3.402,0.319-6.771,0.915-10.076,1.782c5.174-28.403,17.968-54.868,37.013-76.565c20.336-21.349,48.777-33.065,78.251-32.235 c29.614-0.18,57.092,15.395,72.149,40.896c13.271,22.432,20.141,48.071,19.861,74.133C448,246.4,428.16,277.333,398.656,277.333z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgThermostatFan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermostatFan);
export default __webpack_public_path__ + "static/media/thermostat_fan.59f9307e.svg";
export { ForwardRef as ReactComponent };